'use strict';

module.exports =
'<ul class="ad-stack-apps <% if(myapps.content.filter(function (app) { return app.launchUrl }).length > 9) { %>ad-stack-apps--with-button<% } %>">' +
	'<% myapps.content.filter(function(app) { return app.launchUrl }).some(function(app, i) {%>' +
		'<li class="ad-stack-apps--item" href="<%= app.launchUrl %>">' +
			'<div class="ad-stack-apps--item-img-container">' +
				'<% if(app.imageUrl) { %>' +
					'<img class="ad-stack-apps--item-img" src="<%= app.imageUrl %>" />' +
				'<% } else { %>' +
					'<i class="ad-icon-star"></i>' +
				'<% } %>' +
			'</div>' +
			'<div class="ad-stack-apps--item-text"><%= app.name %></div>' +
		'</li>' +
		'<% return i === 8; %>' +
	'<% }) %>' +
		'<li class="ad-stack-apps--item-button">' +
			'<a target="_blank" href="<%= href %>"><%= listAllApps %></a>' +
		'</li>' +
'</ul>';




//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/ad-myapps.tpl.js
// module id = 47
// module chunks = 0